import { Component } from 'react';

// eslint-disable-next-line import/no-cycle
import { Modal } from 'common/components/layout';
import CreditCardListModal from 'profile/creditCard/ListModal';

class CardsOnFile extends Component {
  handleEditCreditCard = (id) => {
    const { props } = this;
    props.handleEditCreditCard(id);
  };

  handleAddCreditCard = (e) => {
    e.preventDefault();
    const { props } = this;
    props.handleAddCreditCard();
  };

  render() {
    const { onCloseModal, onSelectCreditCard } = this.props;
    return (
      <Modal title="Payment details" onCloseModal={onCloseModal}>
        <p>
          <a onClick={this.handleAddCreditCard}>Add Credit Card</a>
        </p>
        <CreditCardListModal
          onSelectCreditCard={onSelectCreditCard}
          onEditCreditCard={this.handleEditCreditCard}
        />
      </Modal>
    );
  }
}

export default CardsOnFile;
